import css from './styles.module.css';

export interface HoverHighlightProps {
  type: 'annotation' | 'data';
  width: number;
  height: number;
  x: number;
  y: number;
}

export function HoverHighlight({
  type,
  width,
  height,
  x,
  y,
}: HoverHighlightProps) {
  const radius = Math.min(width * 0.2, 3);
  const minHeight = Math.max(0, height);
  return (
    <g className={css.hoverHighlight} data-type={type}>
      <rect
        width={width}
        height={minHeight}
        fill="currentColor"
        rx={radius}
        x={x}
        y={y}
      />

      {/* Render a square rect to "remove" rounded bottom corners */}
      {radius > 0 && (
        <rect
          width={width}
          height={radius}
          fill="currentColor"
          x={x}
          y={y + (minHeight - radius)}
        />
      )}
    </g>
  );
}
